// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-cf413ce2] {\r\n  margin-bottom: 5px !important;\r\n  padding-bottom: 0px;\n}\n.v-tab[data-v-cf413ce2] {\r\n  font-family: Montserrat !important;\r\n  text-transform: none !important;\n}\n.last-col-options[data-v-cf413ce2] {\r\n        height: 100%;\n}\r\n", ""]);
// Exports
module.exports = exports;
